// 语义好/坏位查表（前端版）——对照后端 _shared/pptx/v2/semantic.ts 逐条移植
// v1.1 数据组件共享的「涨跌/好坏」色映射，从 V2SKINS 快照的 theme 语义位取（不单独定义色）。
// shadeHex：hex（带 #）→ 明度调整（funnel 单 accent 明度渐变 / bullet 定性色带三档用）。

import type { V2Skin } from "../../lib/v2geo.generated";

export interface SemanticPair {
  /** 好/涨位填充色 */
  good: string;
  /** 坏/跌位填充色 */
  bad: string;
  /** 坏位描边色（magazine 双色调线框区分；其余为 null 无描边） */
  badLine: string | null;
}

export function semanticPair(skin: V2Skin): SemanticPair {
  const t = skin.theme as Record<string, string | undefined>;
  switch (skin.style) {
    case "consult": return { good: t.accentEmerald ?? skin.accent, bad: t.accentCoral ?? skin.sub, badLine: null };
    case "swiss": return { good: skin.accent, bad: skin.sub, badLine: null };
    case "luxe": return { good: skin.accent, bad: t.grey2 ?? skin.hairline, badLine: null };
    case "term": return { good: skin.accent, bad: t.accentRed ?? skin.sub, badLine: null };
    case "brutal": return { good: t.ink ?? skin.text, bad: skin.accent, badLine: null };
    case "report": return { good: skin.accent, bad: t.accentRed ?? skin.sub, badLine: null };
    case "ink": return { good: t.ink ?? skin.text, bad: t.accentGrey ?? skin.sub, badLine: null };
    case "memphis": return { good: t.accentGreen ?? skin.accent, bad: t.accentRed ?? skin.sub, badLine: null };
    case "magazine": return { good: t.ink ?? skin.text, bad: t.paperTint ?? skin.page, badLine: t.ink ?? skin.text };
    default: return { good: skin.accent, bad: skin.sub, badLine: null };
  }
}

/** hex（带 #）→ 明度调整（amount ∈ [-1,1]，正=变浅趋白、负=变深趋黑），返回带 # 的 6 位色 */
export function shadeHex(hex: string, amount: number): string {
  const v = hex.replace("#", "");
  const n = (i: number) => parseInt(v.slice(i * 2, i * 2 + 2), 16);
  const c = [n(0), n(1), n(2)].map((x) => {
    const y = amount >= 0
      ? Math.round(x + (255 - x) * amount)
      : Math.round(x * (1 + amount));
    return Math.max(0, Math.min(255, y));
  });
  return "#" + c.map((x) => x.toString(16).padStart(2, "0")).join("").toUpperCase();
}
